import script from "./User-Login.vue?vue&type=script&setup=true&lang=js"
export * from "./User-Login.vue?vue&type=script&setup=true&lang=js"

import "./User-Login.vue?vue&type=style&index=0&id=c432084e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c432084e"]])

export default __exports__